import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppLayout } from './App';
import { RequireAuth } from './components/RequireAuth';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Products } from './pages/Products';
import { Inventory } from './pages/Inventory';
import { ListingGaps } from './pages/ListingGaps';
import { PurchaseOrders } from './pages/PurchaseOrders';
import { Dealers } from './pages/Dealers';
import { DealerDetail } from './pages/DealerDetail';
import { Reps } from './pages/Reps';
import { Leads } from './pages/Leads';
import { LeadDetail } from './pages/LeadDetail';
import { RepDetail } from './pages/RepDetail';
import { Backfill } from './pages/Backfill';
import { Audit } from './pages/Audit';
import { Config } from './pages/Config';
import { Settings } from './pages/Settings';
import { Account } from './pages/Account';
import { Claims } from './pages/Claims';
import { Fulfilment } from './pages/Fulfilment';
import { PrivacyRequests } from './pages/PrivacyRequests';
import { Cancellations } from './pages/Cancellations';
import { ResaleCertificates } from './pages/ResaleCertificates';
import { ChannelClicks } from './pages/ChannelClicks';

// The app shell is gated by RequireAuth: no session -> redirect to /login. The login
// route itself stays public.
export const router = createBrowserRouter([
  { path: '/login', element: <Login /> },
  {
    path: '/',
    element: (
      <RequireAuth>
        <AppLayout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <Dashboard /> },
      { path: 'products', element: <Products /> },
      { path: 'inventory', element: <Inventory /> },
      { path: 'listing-gaps', element: <ListingGaps /> },
      // 2026-09-28: clicks on the consumer site's /products retailer buttons.
      { path: 'channel-clicks', element: <ChannelClicks /> },
      { path: 'purchase-orders', element: <PurchaseOrders /> },
      { path: 'dealers', element: <Dealers /> },
      { path: 'dealers/:id', element: <DealerDetail /> },
      { path: 'reps', element: <Reps /> },
      { path: 'reps/:id', element: <RepDetail /> },
      // Backlog 1082 — the rep CRM pipeline. Reps are outsourced staff, so their pipeline
      // lives here rather than on cabana-reps. First slice: leads only.
      { path: 'leads', element: <Leads /> },
      { path: 'leads/:id', element: <LeadDetail /> },
      // 2026-09-26: self-service cancellation and delete-my-data, as operators see them.
      { path: 'claims', element: <Claims /> },
      { path: 'fulfilment', element: <Fulfilment /> },
      { path: 'privacy-requests', element: <PrivacyRequests /> },
      { path: 'cancellations', element: <Cancellations /> },
      // 2026-09-26: partner resale certificates, per shipping state (sales-tax exemption).
      { path: 'resale-certificates', element: <ResaleCertificates /> },
      { path: 'backfill', element: <Backfill /> },
      { path: 'audit', element: <Audit /> },
      { path: 'config', element: <Config /> },
      { path: 'settings', element: <Settings /> },
      { path: 'account', element: <Account /> },
    ],
  },
  // Any other path goes to the console's home, which sends a signed-out visitor to /login.
  // Without it an unknown path rendered React Router's bare "Unexpected Application Error!
  // 404 Not Found" with nothing on it to click (found by the walkthrough, 2026-09-25).
  { path: '*', element: <Navigate to="/" replace /> },
]);
